import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${breakpoint('sm')`
      flex-direction: row;
  `}
`;

const SkeletonColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${theme.spacings[5].rem} ${theme.spacings[7].rem};

  ${breakpoint('sm')`      
      & + & {
      border-left: 1px solid ${theme.colors.neutrals.solidGrays[8]};
    }
  `}
`;

const SkeletonBox = styled.div`
  display: flex;
  & > * {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
  }
`;

export const WatchBidsSkeleton = (
  <SkeletonTheme
    baseColor={theme.colors.neutrals.solidGrays[7]}
    highlightColor={theme.colors.neutrals.solidGrays[8]}
    borderRadius={0}
  >
    <Container>
      <SkeletonColumn>
        <Skeleton
          style={{ marginBottom: theme.spacings[4].px }}
          height={60}
          count={3}
        />
        <Skeleton
          style={{
            margin: '0 auto',
            display: 'flex',
          }}
          width={'50%'}
          height={15}
          count={1}
        />
      </SkeletonColumn>
    </Container>
  </SkeletonTheme>
);

export const CartSkeleton = (
  <SkeletonTheme
    baseColor={theme.colors.neutrals.solidGrays[7]}
    highlightColor={theme.colors.neutrals.solidGrays[8]}
    borderRadius={0}
  >
    <Container>
      <SkeletonColumn>
        <Skeleton
          style={{ marginBottom: theme.spacings[4].px }}
          height={60}
          count={3}
        />

        <Skeleton
          style={{
            marginBottom: theme.spacings[4].px,
          }}
          height={15}
          count={2}
        />

        <SkeletonBox>
          <Skeleton
            style={{ marginBottom: theme.spacings[5].px }}
            height={15}
            width={'80%'}
          />
          <Skeleton
            style={{ marginBottom: theme.spacings[5].px }}
            height={15}
            width={'80%'}
          />
        </SkeletonBox>
      </SkeletonColumn>
    </Container>
  </SkeletonTheme>
);
